import { GridColDef } from '@mui/x-data-grid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import { MutableRefObject } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';
import { useVarietiesByCustomer } from '../../../../../services/entities/hooks/useVarietiesByCustomer';
import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
import GenericDataGrid from '../../../../dataGridTables/GenericDataGrid';
import { TableViewData } from './types';

type Props = {
  customerId: string;
  data: TableViewData[];
  isLoading: boolean;
  dataGridApiRef: MutableRefObject<GridApiCommunity>;
};

export const ClusterReportTable = ({
  customerId,
  data,
  isLoading,
  dataGridApiRef,
}: Props) => {
  const { t } = useTranslation();

  const { getVariety, isVarietiesLoading } = useVarietiesByCustomer(customerId);

  const columns = useDeepCompareMemo<GridColDef<TableViewData>[]>(
    () => [
      {
        field: 'scanDate',
        headerName: t('Date'),
        type: 'date',
        disableColumnMenu: true,
      },
      {
        field: 'ranchName',
        headerName: t('Ranch'),
        type: 'string',
        disableColumnMenu: true,
      },
      {
        field: 'blockName',
        headerName: t('Block'),
        type: 'string',
        disableColumnMenu: true,
        sortComparator: (v1: string, v2: string) =>
          v1.localeCompare(v2, undefined, {
            numeric: true,
            sensitivity: 'base',
          }),
      },
      {
        field: 'varietyId',
        headerName: t('Variety'),
        type: 'string',
        valueFormatter: (value: string) =>
          isVarietiesLoading ? '' : getVariety(value)?.name,
        disableColumnMenu: true,
      },
      {
        field: 'filteredClusterCount',
        headerName: t('Cluster'),
        type: 'number',
        renderCell: (params) => {
          return <>{Math.round(params.value).toLocaleString()}</>;
        },
        valueFormatter: (value: number) => Math.round(value),
        disableColumnMenu: true,
      },
    ],
    [t, getVariety, isVarietiesLoading]
  );

  return (
    <GenericDataGrid
      rows={data}
      columns={columns}
      loading={isLoading || isVarietiesLoading}
      disableRowSelectionOnClick
      forceHidePagination
      apiRef={dataGridApiRef}
    />
  );
};
